<template>
  <a-auto-complete
    v-model:value="inputValue"
    class="append-to-parent"
    :class="class"
    
    :disabled="disabled"
    :placeholder="placeholder"
    @select="onSelect"
    @search="onSearch"
    @change="onChange"
    :options="options"
    @blur="onBlur"
  >
    <a-input @keypress="handleKeyPress" show-count allowClear :maxlength="maxlength" />
    <template #option="item">
      <div @click="selectedValue(item)">
        <environment-outlined /> <span class="title">{{ item.title }}</span
        ><span class="subtitle"
          >{{ item.province }} {{ item.city ?? "" }} {{ item.district ?? "" }}</span
        >
      </div>
    </template>
  </a-auto-complete>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  isGlobal: true,
  name: "KeywordMapInput",
});
</script>
<script lang="ts" setup>
import { onMounted, ref, watch } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";
import { EnvironmentOutlined } from "@ant-design/icons-vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { bindEmitter } from "@/utils/emitter";
import { useRoute } from "vue-router";
import { Form } from "ant-design-vue";
interface Option {
  address: string; //地址 省市区
  city: string; // 市
  district: string; //区
  province: string; //省
  title: string; //地点名称
  id: number;
  adcode: number; //行政区划代码
  location: any; //提示所述位置坐标
}
const props = defineProps({
  value: {
    type: String,
    default: "",
  },
  provinceId: {
    type: [Number, String],
    default: 0,
  },
  cityId: {
    type: [Number, String],
    default: 0,
  },
  districtId: {
    type: [Number, String],
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "请选择",
  },
  class: {
    type: String,
    default: "append-to-parent",
  },
  maxlength: {
    type: [Number, String],
    default: 100,
  },
  hasPCD: {// 返回数据是否包括省市区
    type: Boolean,
    default: false,
  },
});
const route = useRoute();
const emit = defineEmits([
  "update:value",
  "update:provinceId",
  "update:cityId",
  "update:districtId",
  "changeLocation",
]);
const locationOptions = ref("");
let suggest;
const onSelect = (value, option) => {
  // console.log("🚀 ~ file: index.vue:33 ~ onSelect ~ value,option:", value, option);
};
const formItemContext = Form.useInjectFormItemContext();
const selectedValue = (item) => {
  if(props.hasPCD){
    inputValue.value =item.address+ item.title;
  }else{
    inputValue.value = item.title;

  }
 
  emit("update:value", inputValue.value);
  // emit("update:provinceId", 2);// 修改详细地址地图带过来时省市区默认传0
  // emit("update:cityId", 2);
  // emit("update:districtId", 0);
  emit("changeLocation", {
    province: item.province,
    city: item.city,
    district: item.district,
  });
  formItemContext.onFieldChange();
};
const inputValue = ref("");
const onChange = async (key) => {
  if (key && suggest) {
    suggest.setCity(locationOptions.value ?? "");
    suggest.search(key, (status, result) => {
      if (status === "complete" && result.tips) {
        options.value = (result.tips || []).map((tip: any) => ({
          ...tip,
          title: tip.name || tip.title,
          address: tip.district || tip.address || "",
          province: "",
          city: "",
          district: tip.district || "",
        }));
      } else {
        options.value = [];
      }
    });
  }
};
const onSearch = (value) => {
  // console.log("🚀 ~ file: index.vue:70 ~ onSearch ~ value:", value);
  emit("update:value", value);
  formItemContext.onFieldChange();
};
const onBlur = () => {
  emit("update:value", inputValue.value);
  formItemContext.onFieldChange();
};
const options = ref<Option[]>([]);
const handleKeyPress = (ev: KeyboardEvent) => {
  // console.log("handleKeyPress", ev);
  // inputValue.value=ev;
};
// 清楚form表单数据
// bindEmitter("change-location-region" + (route.name as string), (name) => {
//   console.log("🚀 ~ file: index.vue:96 ~ bindEmitter ~ name:", name, route.name);
//   if (name) {
//     locationOptions.value = name["city"].name;
//     console.log(
//       "🚀 ~ file: index.vue:95 ~ bindEmitter ~ locationOptions.value:",
//       locationOptions.value
//     );
//   } else {
//     locationOptions.value = "";
//   }

//   inputValue.value = "";
//   options.value = [];
// });

watch(
  () => props.value,
  (n) => {
    inputValue.value = n;
  },
  {
    immediate: true,
  }
);
onMountedOrActivated(() => {
  //@ts-ignore
  // suggest = new TMap.service.Suggestion({
  //   // 新建一个关键字输入提示类
  //   pageSize: 20, // 返回结果每页条目数
  // });
});
</script>
<style lang="less" scoped>
.title {
  padding-left: 5px;
}
.subtitle {
  padding-left: 5px;
  color: #999;
}
</style>
